<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ModelListSelect } from "vue-search-select";
import Loader from "@/components/widgets/preloader";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Store Stock Movement",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Loader,
  },
  data() {
    return {
      title: " Store Stock Movement Report",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Store Stock Movement",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product",
          sortable: true,
          label: "PRODUCT",
        },
        {
          key: "from_quantity",
          sortable: true,
          label: "OLD QUANTITY",
        },
        {
          key: "qty_in",
          sortable: true,
          label: "QTY IN",
        },
        {
          key: "qty_out",
          sortable: true,
          label: "QTY OUT",
        },
        {
          key: "balance",
          sortable: true,
          label: "STOCK BALANCE",
        },
        {
          key: "typename",
          sortable: true,
          label: "TYPE",
        },
        {
          key: "user",
          sortable: true,
          label: "MADE BY",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "date_recorded",
          sortable: true,
          label: "RECORDED ON",
        },
      ],
      id: atob(this.$route.params.id),
      data: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        type: "",
        id:atob(this.$route.params.id)
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      types: [
        {name: "All Types",id: ""},
        {name: "Purchase",id: 0},
        {name: "StoreToShop Transfer",id: 1},
        {name: "ShopToStore Transfer",id: 2},
        {name: "Purchase Return",id: 3},
        {name: "Stock Transfer",id: 4},
        {name: "Reconciliation",id: 5},
        {name: "Spoilt Stock",id: 6},
        {name: "Produced Stock",id: 7},
        {name: "Opening Stock",id: 8},
      ],

      json_fields: {
        PRODUCT: "product",
        FROM_QUANTITY: "from_quantity",
        QUANTITY_IN: "qty_in",
        QUANTITY_OUT: "qty_out",
        STOCK_BALANCE: "balance",
        TYPE: "typename",
        DESCRIPTION: "description",
        MADE_BY: "user",
        DATE: "date",
        RECORDED_ON: "date_recorded"
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  computed: {
    ...mapState("store", ["stock_movements"]),
    ...mapGetters("store", ["StockMovement","FilterStatus"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.StockMovement ? this.StockMovement.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.StockMovement ? this.StockMovement.length : 1;
  },
  methods: {
    ...mapActions({
      FetchMovements: "store/fetchStockMovements",
    }),
    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    
    filterReport() {
      this.FetchMovements(this.data);
    },
  },
  created() {
    this.FetchMovements(this.data);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row py-3">
              <div class="col-md-9">
                <download-excel
                  class="btn btn-info"
                  :data="StockMovement"
                  :fields="json_fields"
                  :worksheet="'STORE STOCK MOVEMENTS ON' + currentdate"
                  type="csv"
                  :name="'Store_StockMovement_Report from ' +data.datefrom+' to '+data.dateto+'.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
              </div>
              <div class="col-md-3">          
                <button @click="$router.go(-1)" class="btn btn-primary btn-sm" >
                  <i class="fas fa-arrow-circle-left"></i> Go Back
                </button>
              </div>  
            </div>            
            <div class="row">
              <h4>
                <center>Store Stock Movements Report from {{ data.datefrom }} to {{ data.dateto }}</center>
              </h4>
              <div class="col-4">
                <div class="form-group">
                  <label>Movement Type</label>
                  <model-list-select
                    :list="types ? types : []"
                    v-model="data.type"
                    option-value="id"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select Type"
                    @change="filterReport()"
                  >
                  </model-list-select>
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label>From</label>
                  <input
                    type="date"
                    v-model="data.datefrom"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label>To</label>
                  <input
                    type="date"
                    v-model="data.dateto"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-2 mt-4">
                <button class="btn btn-primary" type="button" @click="filterReport()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="FilterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="StockMovement ? StockMovement : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(mode_field)="data">
                  {{ data.item.mode.name }} ({{ data.item.mode.type_name }}-{{ data.item.mode.account_number }})
                </template>
              </b-table>
            </div>
            <Loader v-if="!StockMovement"/>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
